import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { AlertType } from '../../utils/types';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-alert-dialog',
  imports: [
    MatDialogActions,
    MatDialogContent,
    MatButtonModule,
    MatDialogTitle
  ],
  standalone: true,
  templateUrl: './alert-dialog.component.html',
})
export class AlertDialogComponent {
  private dialogRef = inject(MatDialogRef<AlertDialogComponent>);
  readonly data = inject<AlertType>(MAT_DIALOG_DATA);
  constructor() {}

  onClose(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
